import * as React from 'react';

import { cn } from '@heidi/utils';

import {
  popoverMenuItemAccessoryStyles,
  popoverMenuItemBaseStyles,
  popoverMenuItemContentStyles,
  popoverMenuItemDescriptionStyles,
  popoverMenuItemDisabledStyles,
  popoverMenuItemIconSelectedStyles,
  popoverMenuItemIconStyles,
  popoverMenuItemTitleBaseStyles,
  popoverMenuItemTitleSelectedStyles,
} from './popover-menu-item.styles';
import type { PopoverMenuItemProps } from './popover-menu-item.types';

const PopoverMenuItem = React.forwardRef<HTMLButtonElement, PopoverMenuItemProps>(
  (
    {
      'data-testid': testId,
      className,
      icon,
      description,
      accessoryEnd,
      selected = false,
      disabled = false,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        data-testid={testId}
        disabled={disabled}
        className={cn(
          popoverMenuItemBaseStyles,
          disabled && popoverMenuItemDisabledStyles,
          className
        )}
        {...props}
      >
        {icon && (
          <span
            className={cn(
              popoverMenuItemIconStyles,
              selected && popoverMenuItemIconSelectedStyles
            )}
          >
            {icon}
          </span>
        )}
        <span className={popoverMenuItemContentStyles}>
          <span
            className={cn(
              popoverMenuItemTitleBaseStyles,
              selected && popoverMenuItemTitleSelectedStyles
            )}
          >
            {children}
          </span>
          {description && (
            <span className={popoverMenuItemDescriptionStyles}>{description}</span>
          )}
        </span>
        {accessoryEnd && (
          <span className={popoverMenuItemAccessoryStyles}>{accessoryEnd}</span>
        )}
      </button>
    );
  }
);
PopoverMenuItem.displayName = 'PopoverMenuItem';

export { PopoverMenuItem };
